import axios from "axios";
import * as Preferences from "./Preferences";

export const GetDashboardStats = (terminalGUID, currentDate, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.ADMIN_HANDLER_GET_DASHBOARD_STATS;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      currentDate: currentDate
    })
    .then(response => {
      console.log("Received response! ", response);

      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);

      if (callback) {
        callback(null);
      }
    });
};

export const SelectBalanceInfo = (terminalGUID, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.ADMIN_HANDLER_SELECT_BALANCE_INFO;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID
    })
    .then(response => {
      console.log("Received response! ", response);

      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);

      if (callback) {
        callback(null);
      }
    });
};

export const SelectTickets = (terminalGUID, dtFrom, dtTo, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL + Preferences.ADMIN_HANDLER_SELECT_TICKETS;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      dateFrom: dtFrom,
      dateTo: dtTo
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetBillFlow = (terminalGUID, dtFrom, dtTo, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL + Preferences.ADMIN_HANDLER_SELECT_BILL_FLOW;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      dateFrom: dtFrom,
      dateTo: dtTo
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetTransactions = (terminalGUID, dtFrom, dtTo, callback) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.ADMIN_HANDLER_SELECT_TRANSACTIONS;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      dateFrom: dtFrom,
      dateTo: dtTo
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetPartialPayoutReceipts = (
  terminalGUID,
  dtFrom,
  dtTo,
  callback
) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.ADMIN_GET_PARTIAL_PAYOUT_RECEIPTS;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      dateFrom: dtFrom,
      dateTo: dtTo
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetEventLog = (terminalGUID, dtFrom, dtTo, callback) => {
  let svcUrl = Preferences.LOCALHOST_BASE_URL + Preferences.ADMIN_GET_EVENT_LOG;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      dateFrom: dtFrom,
      dateTo: dtTo
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const ExtrasClearDB = callback => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL + Preferences.ADMIN_HANDLER_EXTRAS_CLEAR_DB;

  //console.log("CALLING SelectTicketPairs FROM: " + svcUrl);
  //console.log("CALLBACK IS: " + callback);

  //zovi axios
  axios
    .post(svcUrl, {})
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const ResetPaperLength = (terminalGUID, newLengthMM, callback) => {
  console.log("IN SELECT REQUEST...ResetPaperLength");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.ADMIN_HANDLER_RESET_PAPER_LENGTH;

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      newLengthMM: newLengthMM
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};



// WEBPACK FOOTER //
// ./src/Communication/AdminServicesHandler.js